import  wx from  'weixin-js-sdk';
export const initJssdk = (shipment)=>{
    wx.config({
        'appId': shipment.appid,
        'nonceStr': shipment.noncestr,
        'signature': shipment.sign,
        'timestamp': shipment.timestamp,
        'debug': true,
        'jsApiList': ['chooseWXPay', 'hideMenuItems']
    })
    wx.ready(() => {
        hideWxMenus();
        weixinPay(shipment);
    });
}
export const hideWxMenus = () => {
    // 禁用支付分享, 防止订单未生成而进入该页面导致的报错
    const menuList = ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:copyUrl'];
    wx.hideMenuItems({
        menuList // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    });
}
export const weixinPay = (shipment) =>{
    wx.chooseWXPay({
        timestamp: shipment.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: shipment.noncestr, // 支付签名随机串，不长于 32 位
        package: shipment.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*） 该参数需要openid
        signType: shipment.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: shipment.sign, // 支付签名 参与签名的参数为：appId、timeStamp、nonceStr、package、signType
        success: function (res){
            Notify({ type: 'succsee', message: '成功' });
            window.location.replace(shipment.jumpurl)
        }, //公共查询结果接口
        fail: function (res) {
            Notify({ type: 'danger', message: res });
            window.location.replace(shipment.jumpurl)
        }, //失败处理
        cancel: function (res) {
            window.location.replace(shipment.jumpurl)
        }, //取消处理
        complete({ errMsg }) {
            Notify({ type: 'primary', message: '完成' });
            window.location.replace(shipment.jumpurl)
        }
    });
}
